var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "List"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 6C7 6.09946 6.97366 6.19484 6.92678 6.26517C6.87989 6.33549 6.8163 6.375 6.75 6.375H1.25C1.1837 6.375 1.12011 6.33549 1.07322 6.26517C1.02634 6.19484 1 6.09946 1 6C1 5.90054 1.02634 5.80516 1.07322 5.73484C1.12011 5.66451 1.1837 5.625 1.25 5.625H6.75C6.8163 5.625 6.87989 5.66451 6.92678 5.73484C6.97366 5.80516 7 5.90054 7 6ZM1.25 3.375H6.75C6.8163 3.375 6.87989 3.33549 6.92678 3.26516C6.97366 3.19484 7 3.09946 7 3C7 2.90054 6.97366 2.80516 6.92678 2.73484C6.87989 2.66451 6.8163 2.625 6.75 2.625H1.25C1.1837 2.625 1.12011 2.66451 1.07322 2.73484C1.02634 2.80516 1 2.90054 1 3C1 3.09946 1.02634 3.19484 1.07322 3.26516C1.12011 3.33549 1.1837 3.375 1.25 3.375ZM6.75 8.625H1.25C1.1837 8.625 1.12011 8.66451 1.07322 8.73483C1.02634 8.80516 1 8.90054 1 9C1 9.09946 1.02634 9.19484 1.07322 9.26517C1.12011 9.33549 1.1837 9.375 1.25 9.375H6.75C6.8163 9.375 6.87989 9.33549 6.92678 9.26517C6.97366 9.19484 7 9.09946 7 9C7 8.90054 6.97366 8.80516 6.92678 8.73483C6.87989 8.66451 6.8163 8.625 6.75 8.625Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDrop);
export default __webpack_public_path__ + "static/media/drag-drop.7b9fbbdcfcb471da5a742012802b0f44.svg";
export { ForwardRef as ReactComponent };